import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import EventsSection, { EventsSectionHandle } from "@/components/EventsSection";
import HowItWorks from "@/components/HowItWorks";
import Footer from "@/components/Footer";
import FirstEventBonusBanner from "@/components/FirstEventBonusBanner";
import { useBidNotifications } from "@/hooks/useBidNotifications";

const Index = () => {
  useBidNotifications();
  const location = useLocation();
  const eventsSectionRef = useRef<EventsSectionHandle>(null);

  useEffect(() => {
    // Scroll to hash section when navigating from another page
    if (location.hash) {
      setTimeout(() => {
        const element = document.querySelector(location.hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  }, [location.hash]);

  const handleCreateEvent = () => {
    // Scroll to events section and trigger modal
    const eventsSection = document.getElementById("events");
    if (eventsSection) {
      eventsSection.scrollIntoView({ behavior: "smooth" });
    }
    // Small delay to let scroll complete, then open modal
    setTimeout(() => {
      eventsSectionRef.current?.openCreateModal();
    }, 500);
  };

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <FirstEventBonusBanner onCreateEvent={handleCreateEvent} />
      <Hero />
      <EventsSection ref={eventsSectionRef} />
      <HowItWorks />
      <Footer />
    </div>
  );
};

export default Index;
